"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Disclaimer = void 0;
var react_1 = __importStar(require("react"));
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var doshx_controls_web_1 = require("doshx_controls_web");
var main_1 = require("../../../../../reducers/slices/main");
var react_redux_1 = require("react-redux");
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var sampleAppController_1 = require("./../../../../../../facetec/src/sampleAppController");
var clear_action_auth_1 = require("../../../../../api/calls/user/authentication/clear_action_auth");
var pep_pip_verification_1 = require("../../../pep_pip_verification");
var Disclaimer = function (props) {
    var onProceed = props.onProceed;
    var cookie = new universal_cookie_1.default();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_1.useState)(false), isSaving = _a[0], setIsSaving = _a[1];
    var _b = (0, react_1.useState)(false), terms1 = _b[0], setTerms1 = _b[1];
    var _c = (0, react_1.useState)(false), terms2 = _c[0], setTerms2 = _c[1];
    var _d = (0, react_1.useState)(false), terms3 = _d[0], setTerms3 = _d[1];
    var intervalId;
    return (react_1.default.createElement("div", { className: "w-[700px]  flex flex-col gap-4" },
        react_1.default.createElement("div", { className: "flex flex-row items-center justify-start" },
            react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { size: "medium", label: "", value: terms1, onChange: function () {
                    setTerms1(!terms1);
                } }),
            react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "small", textColor: "text-black", label: "I am of the intent to apply for and obtain credit or services from one or more of the Credit Providers supporting Sky LifeStyle App with credit provision to their users, as listed on the App, and this will serve as mandate and authorization to supply all of my application detail to any an all such Credit or Service Providers (hereinafter referred to as the \u201CLENDER\u201D)" })),
        react_1.default.createElement("div", { className: "flex flex-row items-center justify-start" },
            react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { size: "medium", label: "", value: terms2, onChange: function () {
                    setTerms2(!terms2);
                } }),
            react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "small", textColor: "text-black", label: "I declare that all of the information supplied by me in this application is true and correct." })),
        react_1.default.createElement("div", { className: "flex flex-row items-center justify-start" },
            react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { size: "medium", label: "", value: terms3, onChange: function () {
                    setTerms3(!terms3);
                } }),
            react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "small", textColor: "text-black", label: "I, the applicant, agree that the \u201CLENDER\u201D is entitled to make any enquiries to verify and research any details provided by me in this application, access the files of any credit bureau to ascertain my credit profile when assessing this application and at any time during the currency of a resulting account, disclose the existence and conduct of such an account, whether still current or not, to any credit bureau or credit grantor, and/or place my name on their own marketing mailing list, provided it be removed if so be requested by me." })),
        react_1.default.createElement("div", { className: "flex justify-center" },
            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Proceed", backgroundColor: "bg-secondary", size: "small", loading: isSaving, enabled: !isSaving, endIcon: pro_solid_svg_icons_1.faArrowRight, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var clearData, checkCookie_1, handleVerificationSuccess;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(terms1 && terms2 && terms3)) return [3 /*break*/, 2];
                                return [4 /*yield*/, (0, clear_action_auth_1.clear_action_auth)()];
                            case 1:
                                clearData = _a.sent();
                                if (!clearData.success) {
                                    setIsSaving(false);
                                    return [2 /*return*/];
                                }
                                checkCookie_1 = function () {
                                    var userStateCookie = cookie.get("user_state");
                                    if (userStateCookie === null || userStateCookie === void 0 ? void 0 : userStateCookie.facetec.action_authenticated) {
                                        onProceed();
                                        dispatch((0, main_1.setContentModal)(null));
                                        clearInterval(intervalId);
                                    }
                                    else {
                                        setIsSaving(false);
                                    }
                                };
                                handleVerificationSuccess = function () {
                                    // Use an interval to check for changes in the cookie
                                    intervalId = setInterval(checkCookie_1, 5000); // Check every 5 second
                                    sampleAppController_1.SampleApp.onAuthenticateUserPressed();
                                };
                                dispatch((0, main_1.setContentModal)({
                                    title: "Prominent Influential Person (PIP) Declaration",
                                    content: react_1.default.createElement(pep_pip_verification_1.PepPipVerification, { onProceed: handleVerificationSuccess }),
                                }));
                                return [3 /*break*/, 3];
                            case 2:
                                dispatch((0, main_1.setMessageModal)({
                                    title: "Please agree to terms!",
                                    messages: ["To proceed, you need to agree to all the terms and conditions."],
                                }));
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                }); } }))));
};
exports.Disclaimer = Disclaimer;
